import { canUseProductionAnalytics, canUseTestAnalytics, resolveGoogleTagId } from '../config/google-analytics.mjs';

export function browserAnalyticsSettings() {
  if (typeof window === 'undefined') return { enabled: false };
  const deployment = process.env.NEXT_PUBLIC_ANALYTICS_DEPLOYMENT;
  if (deployment === 'production' && process.env.NEXT_PUBLIC_ANALYTICS_TEST_ENABLED === 'true') return { enabled: false };
  const testId = process.env.NEXT_PUBLIC_GA_TEST_MEASUREMENT_ID;
  let tagId;
  try { tagId = resolveGoogleTagId(
    deployment !== 'production' && process.env.NEXT_PUBLIC_ANALYTICS_TEST_ENABLED === 'true' ? testId : process.env.NEXT_PUBLIC_GOOGLE_TAG_ID,
    process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID,
  ); } catch { return { enabled: false }; }
  const settings = { hostname: window.location.hostname, protocol: window.location.protocol, deployment,
    nodeEnv: process.env.NODE_ENV, tagId, testId, testHost: process.env.NEXT_PUBLIC_ANALYTICS_TEST_HOSTNAME,
    testEnabled: process.env.NEXT_PUBLIC_ANALYTICS_TEST_ENABLED === 'true' };
  return { ...settings, enabled: canUseProductionAnalytics(settings) || canUseTestAnalytics(settings) };
}
